import { render, staticRenderFns } from "./RegisterPopup.vue?vue&type=template&id=3d66d7a6"
import script from "./RegisterPopup.vue?vue&type=script&lang=js"
export * from "./RegisterPopup.vue?vue&type=script&lang=js"
import style0 from "./RegisterPopup.vue?vue&type=style&index=0&id=3d66d7a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports